import qs from "qs";

export class SellAndRentClient {
  constructor(httpClient, baseURL) {
    this.httpClient = httpClient;
    this.baseURL = `${baseURL}/sell_and_rent`;
  }

  async listForms(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });
    const url = `${this.baseURL}/forms${queryString}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async put(id, params) {
    const url = `${this.baseURL}/forms/${id}`;

    const response = await this.httpClient.request("put", url, {
      data: params
    });

    return response;
  }

  async getForm(id) {
    const url = `${this.baseURL}/forms/${id}`;

    const response = await this.httpClient.request("get", url);

    return response;
  }

  async getReport(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true
    });

    const url = `${this.baseURL}/forms/report${queryString}`;

    const response = await this.httpClient.request("get", url, {
      responseType: "blob"
    });

    return response;
  }
}



// WEBPACK FOOTER //
// ./src/clients/BaanRueJaiClient/homes/sell-and-rent.js